import { createAction, WP_BLOGS } from '@wix/communities-blog-client-common';

export const SET_ENABLE_LINKIFY = 'editorConfig/SET_ENABLE_LINKIFY';

export const setEnableLinkfify = createAction(SET_ENABLE_LINKIFY, (instanceId) => {
  return !WP_BLOGS.includes(instanceId);
});
